// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {alertService} from "../../../services/AlertService";

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getRental, insertRental, rentalSelector, updateRental,} from "./rentalSlice";

import {Colors} from "../../../assets/Colors";

const RentalPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const rental = useSelector(rentalSelector);

    useEffect(() => {
        dispatch(
            getRental({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && rental.isGetSuccess && !rental.isGetFetching) {
            let calc = rental?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = rental.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && rental.isGetSuccess && !rental.isGetFetching) {
            let calc = rental?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = rental.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !rental?.isGetFetching &&
            rental.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = rental?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = rental.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getRental({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (rental.isGetSuccess) {
                alertService.success(rental.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getRental({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (rental.isUpdateSuccess) {
                alertService.success(rental.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateRental({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetRental(params) {
    //   return dispatch(getRental(params));
    // }

    function handleInsertRental(param) {
        setInsertFetch(true);
        const params = {
            RentalName: param.inputOneValue,
            CategoryID: param.dropDownRentalValue,
        };

        dispatch(insertRental(params));
    }

    function handleUpdateRental(param) {
        setUpdateFetch(true);

        const params = {
            RentalName: param.inputOneValue,
            RentalID: currentData.RentalID,
            status: param.status,
            CategoryID: param.dropDownRentalValue,
        };
        dispatch(updateRental(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getRental(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getRental(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = rental.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? rental.count : newCount,
            search: search,
        };
        dispatch(getRental(params));

        setPage(1);
        setCount(newCount === "-1" ? rental.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>
                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Rental"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Rental"
                                tableData={rental.data}
                                colOneTitle="ID"
                                colOneData="RentalID"
                                colTwoTitle="Nama Rental"
                                colTwoData="RentalName"
                                colThreeTitle="Kelompok"
                                colThreeData="CategoryName"
                                status="Status"
                                fetching={rental.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        dropDownRental={true}
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Rental"
                        inputOneTitle="Nama Rental"
                        inputOneValue=""
                        submitButtonTitle="Submit"
                        dropDownRentalValue={currentData.CategoryID}
                        handleSubmit={handleInsertRental}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        dropDownRental={true}
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.RentalID}
                        modal={handleModal}
                        modalTitle="Ubah Rental"
                        inputOneTitle="Nama Rental"
                        inputOneValue={currentData.RentalName}
                        dropDownRentalValue={currentData.CategoryID}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateRental}
                    />
                )}
            </div>
        );
    }
};

export default RentalPage;
